module.exports = "/_next/static/images/img-super-benefit-2-5ccfdc886364b304bbd5eb3a6e0b896f.svg";